import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ExpenseFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  categories,
  vendors,
  paymentMethods 
}) => {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          <span>Filter Expenses</span>
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          Clear Filters
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          label="Search"
          placeholder="Search expenses..."
          value={filters?.search}
          onChange={(e) => handleInputChange('search', e?.target?.value)}
        />

        <Input
          type="date"
          label="From Date"
          value={filters?.fromDate}
          onChange={(e) => handleInputChange('fromDate', e?.target?.value)}
        />

        <Input
          type="date"
          label="To Date"
          value={filters?.toDate}
          onChange={(e) => handleInputChange('toDate', e?.target?.value)}
        />

        <Input
          type="text"
          label="Category"
          placeholder="Filter by category..."
          value={filters?.category === 'all' ? '' : filters?.category}
          onChange={(e) => handleInputChange('category', e?.target?.value || 'all')}
        />

        <Input
          type="text"
          label="Vendor"
          placeholder="Filter by vendor..."
          value={filters?.vendor === 'all' ? '' : filters?.vendor}
          onChange={(e) => handleInputChange('vendor', e?.target?.value || 'all')}
        />

        <Select
          label="Payment Method"
          options={paymentMethods}
          value={filters?.paymentMethod}
          onChange={(value) => handleInputChange('paymentMethod', value)}
          clearable
        />

        <div className="flex items-end">
          <Input
            type="number"
            label="Min Amount"
            placeholder="0.00"
            value={filters?.minAmount}
            onChange={(e) => handleInputChange('minAmount', e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default ExpenseFilters;